export const paymentMethods = [
    {
        name: 'Automated',
        localizationSlug: 'AUTOMATED',
        value: 'automated',
    },
    {
        name: 'Manual/ACH',
        localizationSlug: 'MANUAL_ACH',
        value: 'manual',
    },
];
export const paymentStatus = {
    INTERNAL_REVIEW: 'internal_review',
    APPROVED_INTERNALLY: 'approved_internally',
    PAYMENT_INITIALIZED: 'payment_initialized',
    PAID: 'paid',
    VOID: 'void',
};
export const AUTOMATED_PAYMENT_EVENTS = [
    'stripe_credit_card_payment_successful',
    'stripe_credit_card_payment_failed',
];
